export default {
  name: "AutocompleteField",
  props: {
    rules: {
      default: () => [],
      type: Array,
    },
    responsive: {
      default: () => {
        return {
          cols: "12",
          sm: "12",
          md: "12",
          lg: "12",
        };
      },
      type: Object,
    },
    options: {
      required: true,
    },
    vModel: {
      required: true,
    },
    multiple: {
      default: false,
      type: Boolean,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    loading: {
      default: false,
      type: Boolean,
    },
    title: {
      default: true,
      type: String,
    },
    id: {
      required: true,
      type: String,
    },
  },

  created() {
    this.value = this.vModel;
  },

  watch: {
    value() {
      this.$emit("input", this.value);
    },

    vModel() {
      this.value = this.vModel;
    },
  },

  data: () => ({
    value: null,
  }),
};
